import React from "react";
import Image from "next/image";
import { logError } from "@/services/DatadogService/DatadogService";

import type { QRProps } from "@/contexts/QREditorContext/types";

interface Mp3AudioContentProps {
  data: NonNullable<QRProps<"mp3">["data"]>;
  isInitialPreview: boolean;
  hasAudioFile: boolean;
}

export const Mp3AudioContent = ({ data, isInitialPreview, hasAudioFile }: Mp3AudioContentProps) => {
  const handleAudioError = (event: React.SyntheticEvent<HTMLAudioElement, Event>) => {
    const audioElement = event.currentTarget;
    const audioError = new Error(
      `Audio load failed: ${audioElement.error?.message || "Unknown error"}`
    );

    logError(audioError, {
      component: "Mp3AudioContent",
      action: "audio_load_failed",
      audioSrc: data?.mp3FileUrl,
      fileName: data?.mp3FileName,
    });
  };

  if (hasAudioFile) {
    return (
      <div
        key={data?.mp3FileName}
        className="mp3-template__audio-wrapper"
      >
        <audio
          controls
          controlsList={!data?.allowDownload ? "nodownload" : undefined}
          preload="auto"
          onError={handleAudioError}
        >
          <source
            src={data?.mp3FileUrl}
            type="audio/mpeg"
          />
          <p>
            Your browser does not support HTML5 audio. Here is a{" "}
            <a href={data?.mp3FileUrl}>link to the audio</a> instead.
          </p>
        </audio>
      </div>
    );
  }
  if (isInitialPreview) {
    return (
      <Image
        className="mp3-template__audio-placeholder"
        src="/images/phone-previews/defaultPreview/audio-controls.png"
        alt="audio controls placeholder"
        width={180}
        height={60}
        onError={() => {
          const imgError = new Error("Audio placeholder image failed to load");
          logError(imgError, {
            component: "Mp3AudioContent",
            action: "placeholder_image_failed",
          });
        }}
      />
    );
  }

  return null;
};
